import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon, BadgeCheckIcon, CheckCircleIcon } from 'lucide-react';
const results = ['Mayor energía durante el día.', 'Mejor calidad de sueño.', 'Reducción visible de inflamación abdominal.', 'Menos ansiedad e irritabilidad.', 'Mayor claridad mental.', 'Más confianza y conexión consigo mismas.'];
const testimonials = [{
  name: 'María Elena G.',
  initials: 'ME',
  color: 'bg-[#C48B8B]',
  text: 'Después de 3 semanas siguiendo la guía, mis sofocos disminuyeron muchísimo. Duermo mejor y me siento con más energía. ¡Ojalá hubiera encontrado esto antes!'
}, {
  name: 'Carmen L.',
  initials: 'CL',
  color: 'bg-[#7C9A6E]',
  text: 'Las recetas son deliciosas y fáciles de preparar. Mi abdomen se desinflamó notablemente y ya no tengo esa sensación de pesadez constante.'
}, {
  name: 'Patricia R.',
  initials: 'PR',
  color: 'bg-[#C9A96E]',
  text: 'Lo que más me ayudó fueron las meditaciones guiadas. Mi ansiedad bajó muchísimo y ahora puedo manejar mejor los cambios de humor.'
}, {
  name: 'Ana Sofía M.',
  initials: 'AS',
  color: 'bg-[#A0525A]',
  text: 'Tenía mucha niebla mental y problemas para concentrarme. Con los hábitos de la guía, recuperé mi claridad mental. Me siento yo misma otra vez.'
}, {
  name: 'Lucía V.',
  initials: 'LV',
  color: 'bg-[#6B8F5E]',
  text: 'El método batch cooking me cambió la vida. Ahora como saludable sin pasar horas en la cocina. Bajé 4 kilos sin hacer dieta estricta.'
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 px-4 bg-white" ref={ref} data-id="element-151">
      <div className="max-w-6xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2926] mb-4" data-id="element-154">
            RESULTADOS QUE PUEDES ESPERAR
          </h2>
          <p className="text-lg text-[#2D2926]/70" data-id="element-155">
            Mujeres que aplican esta guía reportan:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12 max-w-3xl mx-auto" data-id="element-156">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center gap-2 text-sm md:text-base" data-id="element-157">
              <CheckCircleIcon className="w-5 h-5 text-[#6B8F5E] flex-shrink-0" data-id="element-158" />
              <span className="text-[#2D2926]/80" data-id="element-159">{result}</span>
            </motion.div>)}
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-160">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.6 + index * 0.1
        }} className="break-inside-avoid bg-[#FAF7F2] rounded-xl p-6 border border-[#7C9A6E]/10" data-id="element-161">
              <div className="flex items-center gap-1 mb-3" data-id="element-162">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#C9A96E] text-[#C9A96E]" data-id="element-163" />)}
              </div>
              <p className="text-[#2D2926]/80 mb-4 leading-relaxed italic" data-id="element-164">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-165">
                <div className={`w-10 h-10 rounded-full ${testimonial.color} flex items-center justify-center text-white font-bold text-sm`} data-id="element-166">
                  {testimonial.initials}
                </div>
                <div data-id="element-167">
                  <p className="font-semibold text-[#2D2926]" data-id="element-168">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-[#6B8F5E] flex items-center gap-1" data-id="element-169">
                    <BadgeCheckIcon className="w-3 h-3" data-id="element-170" />
                    Compra Verificada
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}